/**
 * Tiny shared helpers — keep this file dependency-light so it can be
 * imported from anywhere (components, hooks, pages).
 */

import clsx, { type ClassValue } from "clsx";

/** Tailwind class merge — same signature as the popular `cn` from shadcn. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

/** Generate short IDs for client-only entities (sections, items). */
export function shortId(prefix = "id"): string {
  // 8 random base36 chars — enough for client-side uniqueness within a session.
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${rand}`;
}

/** Sleep for `ms` milliseconds. Useful in tests and for debouncing manual flows. */
export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** Type guard: narrow `unknown` to a plain object. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
